// ─────────────────────────────────────────────
//  Reviews — full review list with reply & follow-up
// ─────────────────────────────────────────────
import Stars from "../components/Stars";
import { PLATFORMS, SAMPLE_REVIEWS } from "../lib/data";

export default function Reviews() {
  return (
    <div>
      <h1 style={{ margin: "0 0 6px", fontSize: 26, fontWeight: 900, letterSpacing: "-0.03em" }}>
        All Reviews
      </h1>
      <p style={{ margin: "0 0 24px", color: "rgba(255,255,255,0.4)", fontSize: 13 }}>
        143 reviews across all platforms
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {SAMPLE_REVIEWS.map((r) => {
          const p = PLATFORMS.find((x) => x.id === r.platform);
          return (
            <div
              key={r.id}
              style={{
                background: "rgba(255,255,255,0.04)",
                border: `1px solid ${r.flagged ? "rgba(211,35,35,0.3)" : "rgba(255,255,255,0.07)"}`,
                borderRadius: 14, padding: "16px 18px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div
                    style={{
                      width: 36, height: 36, borderRadius: "50%",
                      background: `${p.color}22`,
                      border: `1.5px solid ${p.color}44`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: p.color, fontWeight: 800, fontSize: 14,
                    }}
                  >
                    {r.name[0]}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}>
                      {r.name}
                      {r.flagged && (
                        <span style={{ fontSize: 10, padding: "2px 7px", borderRadius: 6, background: "rgba(211,35,35,0.2)", color: "#ff6b6b" }}>
                          🔒 Private
                        </span>
                      )}
                      {r.photo && (
                        <span style={{ fontSize: 10, padding: "2px 7px", borderRadius: 6, background: "rgba(255,190,11,0.15)", color: "#FFBE0B" }}>
                          📷 Photo
                        </span>
                      )}
                    </div>
                    <Stars value={r.stars} size={14} />
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 11, color: p.color, fontWeight: 700 }}>{p.name}</div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.25)", marginTop: 2 }}>{r.time}</div>
                </div>
              </div>

              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.65 }}>
                {r.text}
              </div>

              {r.tags.length > 0 && (
                <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginTop: 10 }}>
                  {r.tags.map((t) => (
                    <span key={t} style={{ fontSize: 10, padding: "3px 8px", borderRadius: 10, background: "rgba(255,190,11,0.12)", color: "#FFBE0B" }}>
                      {t}
                    </span>
                  ))}
                </div>
              )}

              <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
                <button
                  style={{
                    padding: "6px 14px", borderRadius: 8,
                    border: "1px solid rgba(255,255,255,0.1)",
                    background: "transparent", color: "rgba(255,255,255,0.4)",
                    fontSize: 11, cursor: "pointer", fontFamily: "inherit",
                  }}
                >
                  💬 Reply
                </button>
                {r.flagged && (
                  <button
                    style={{
                      padding: "6px 14px", borderRadius: 8,
                      border: "1px solid rgba(255,107,53,0.3)",
                      background: "rgba(255,107,53,0.1)",
                      color: "#FF6B35", fontSize: 11,
                      cursor: "pointer", fontFamily: "inherit",
                    }}
                  >
                    📧 Follow Up
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
